<script setup lang="ts">
import { type ScriptInput } from '@clovyr/pollen/manifest/script';

import FormField from '@/components/blocks/FormField.vue';
import PasswordFormField from '@/components/blocks/PasswordFormField.vue';

const { input, disabled } = defineProps<{ input: ScriptInput; disabled: boolean }>();

const inputName = computed(() => {
  return input.var.toLowerCase();
});

const inputType = computed(() => {
  if (input.type === 'password') {
    return 'password';
  }
  return 'string';
});
</script>
<template>
  <FormField
    v-if="inputType === 'string'"
    :label="input.name"
    :name="inputName"
    :tooltip="input.description"
    :placeholder="input.placeholder"
    :validate-on-blur="false"
    :disabled
  />
  <PasswordFormField
    v-else-if="inputType === 'password'"
    :label="input.name"
    :name="inputName"
    :tooltip="input.description"
    :placeholder="input.placeholder"
    :validate-on-blur="false"
    :disabled
    reveal
  />
</template>
